import type { RecurringDetailsRequestDTO } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';
import type { DepositoryTransferRequest } from './useCreateDepositoryTransfer';

export interface CreatePaymentScheduleResult {
    id: string;
    status: string;
}

export type CreatePaymentScheduleRequest = DepositoryTransferRequest &
    RecurringDetailsRequestDTO;

const useCreatePaymentSchedule = requestBuilder.mutation<
    CreatePaymentScheduleResult,
    CreatePaymentScheduleRequest
>({
    endpoint: '/api/payment-schedules/createPaymentSchedule',
    method: 'POST',
});

export default useCreatePaymentSchedule;
